import React, { Suspense } from "react";
import { Container, Title, Button, Text, Group } from "@mantine/core";
import { IconArrowRight } from "@tabler/icons-react";
import { scroller } from "react-scroll";
import classes from "./hero.module.scss";

const scrollTo = (target) =>
  scroller.scrollTo(target, {
    duration: 800,
    smooth: "easeInOutQuart",
    offset: -70,
  });

const HeroContent = () => {
  return (
    <section className={classes.hero}>
      <Container size="lg" className={classes.container}>
        <div className={classes.imageCol}>
          <div className={classes.imageGlow} />
          <picture>
            <source
              type="image/avif"
              srcSet="/optimized/Portrett-480.avif 480w, /optimized/Portrett-768.avif 768w, /optimized/Portrett-1024.avif 1024w"
              sizes="(max-width: 768px) 92vw, 520px"
            />
            <source
              type="image/webp"
              srcSet="/optimized/Portrett-480.webp 480w, /optimized/Portrett-768.webp 768w, /optimized/Portrett-1024.webp 1024w"
              sizes="(max-width: 768px) 92vw, 520px"
            />
            <img
              src="/optimized/Portrett-768.jpg"
              alt="Henning Langseth – helsecoach"
              className={classes.portrait}
              width="1024"
              height="683"
              loading="eager"
              fetchpriority="high"
              decoding="async"
            />
          </picture>
        </div>

        <div className={classes.textCol}>
          <span className={classes.eyebrow}>1:1 helhetlig helsecoaching</span>

          <Title order={1} className={classes.title}>
            Ekte transformasjon —{" "}
            <span className={classes.gradientText}>som faktisk varer</span>
          </Title>

          <Text className={classes.description}>
            Helseveiledning bygget på forskning, erfaring og sunn fornuft. For
            deg som vil ha en sunnere kropp og et skarpere hode — uten strenge
            dietter, kalori­telling eller at livsgnisten forsvinner på veien.
          </Text>

          <Group className={classes.actions} gap="md">
            <Button
              variant="gradient"
              gradient={{ from: "teal", to: "green" }}
              size="lg"
              radius="xl"
              rightSection={<IconArrowRight size={18} />}
              onClick={() => scrollTo("contact")}
            >
              Kom i gang
            </Button>
            <Button
              variant="default"
              size="lg"
              radius="xl"
              onClick={() => scrollTo("features")}
            >
              Se hva du får
            </Button>
          </Group>

          <div className={classes.trustRow}>
            <span>Forskningsbasert</span>
            <span className={classes.dot} />
            <span>Helhetlig tilnærming</span>
            <span className={classes.dot} />
            <span>Skreddersydd 1:1</span>
          </div>
        </div>
      </Container>
    </section>
  );
};

export const HeroComponent = () => (
  <Suspense fallback={<div>Loading...</div>}>
    <HeroContent />
  </Suspense>
);
